import PageLayout from "../../components/UI/Layout/PageLayout";
import { Outlet } from "react-router-dom";

export default function LocataireRootPage() {
  return (
    <PageLayout isTenant>
      <Outlet />
    </PageLayout>
  );
}
